import client from "../utils/client";
import { authHeaders } from "../utils/authHeaders";

/**
 * Closing a position with a preview first (addendum v1.5 S9).
 *
 * preview(id) asks the server for the exact payout -- the same figure the
 * close itself computes. close(id, expectedTotal) sends that previewed
 * total back; if the server's figure has moved since (an accrual landed in
 * between), it refuses with CLOSE_AMOUNT_CHANGED and writes nothing.
 *
 * Both return the axios response promise; callers handle errors. The
 * token is read at request time (authHeaders), not from AuthContext, whose
 * token is empty right after a first login.
 */
const useClosePosition = () => {
  const preview = (investmentId) =>
    client({
      url: `/pool/investment/${investmentId}/close-preview`,
      method: "GET",
      headers: authHeaders(),
    }).then((res) => res.data.data);

  const close = (investmentId, expectedTotal) =>
    client({
      url: `/pool/deactivate`,
      data: { investmentId, expectedTotal },
      method: "POST",
      headers: authHeaders(),
    });

  return { preview, close };
};

export default useClosePosition;
